import { motion } from "framer-motion";
import { lineReveal } from "@/lib/motion";

/**
 * Wraps each item in an overflow-hidden mask and reveals from below.
 * Pass `lines` array of strings/nodes.
 */
export default function MaskedReveal({
    lines,
    as: Tag = "h1",
    className = "",
    lineClassName = "",
    delay = 0,
}) {
    return (
        <Tag className={className}>
            {lines.map((line, i) => (
                <span key={i} className="reveal-line">
                    <motion.span
                        style={{ display: "inline-block" }}
                        className={lineClassName}
                        variants={lineReveal}
                        initial="hidden"
                        animate="show"
                        custom={i + delay}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}
